module.exports = __webpack_public_path__ + "img/air-freight.0ff4168a.png";